import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/Delete';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { ServiceContext } from '../../context/ServicesContext';
import { NotificationContext } from '../../context/NotificationContext';
import { TranslationContext } from '../../context/TranslationContext';
import { ConfirmDialog } from '../../components/ConfirmDialog';
import { IUser } from '../../services/ApiServiceV1';
import { StyledLink } from '../../components/StyledLink';
import { RouteMapContext } from '../../context/RouteMapContext';
import { ModalContext } from '../../context/ModalContext';
import { useContext } from 'react';

const UserTableRow: React.FunctionComponent<IUser> = ({ client, user }) => {
  const { getPathWithProps } = useContext(RouteMapContext);
  const { setModalState, setIsModalOpen } = useContext(ModalContext);
  const {
    stores: { usersStore },
  } = useContext(ServiceContext);
  const { notificationDispatch } = useContext(NotificationContext);
  const { translate } = useContext(TranslationContext);

  return (
    <TableRow>
      <TableCell>{client !== null ? client.name : ''}</TableCell>
      <TableCell>
        <StyledLink to={getPathWithProps<{ userId: string }>('EDIT_USER', { userId: (user.id as unknown) as string })}>
          {user.displayName}
        </StyledLink>
      </TableCell>
      <TableCell>{client !== null ? client.country.name : ''}</TableCell>
      <TableCell>{user.externalUserState}</TableCell>
      <TableCell align="right">
        <IconButton
          onClick={() => {
            setModalState(
              true,
              <ConfirmDialog
                data={user.id}
                handleClick={async (userId) => {
                  try {
                    await usersStore.removeExternalUser(userId!);
                    await usersStore.fetch(true);

                    notificationDispatch({
                      type: 'SET_NOTIFICATION',
                      payload: {
                        message: translate('successfully saved'),
                        color: 'success',
                      },
                    });
                  } catch (e) {
                    notificationDispatch({
                      type: 'SET_NOTIFICATION',
                      payload: {
                        message: translate('failed to fetch data'),
                        color: 'error',
                      },
                    });
                  } finally {
                    setIsModalOpen(false);
                  }
                }}
                dialogTitle={translate('Are you sure you want to delete?')}
                recordTitle={''}
                content={''}
                primaryButtonLabel={translate('yes')}
                cancelLabel={translate('no')}
              />,
            );
          }}
        >
          <Delete fontSize="small" color="action" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export { UserTableRow };
